import React, { useEffect, useContext } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { createTheme, NextUIProvider } from "@nextui-org/react"
import Home from './pages/Home/Home';
import Explorer from './pages/Explorer/Explorer';
import Login from './pages/Login/Login';
import { UserProvider, UserContext } from "utils/context";
import Header from "components/Header";

import './index.scss';
import UserPanel from 'pages/UserPanel/UserPanel';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Client from 'pages/Client/Client';
import Referent from 'pages/Referent/Referent';
import themes from "utils/themes";
import Panel from 'pages/Panel/Panel';

const App = () => {
  const [user] = useContext(UserContext);

  useEffect(() => {
    themes.select("light");
  }, [])
  return <div className='app'>
      <BrowserRouter>
          <Header />
          <ToastContainer theme='dark' />
          <Routes>
            <Route exact path="/" element={(user) ? <Home /> : <Login />}></Route>

            {(Boolean(user)) && <>
              <Route path="/panel" element={<Panel />}></Route>

              <Route path="/explorer" element={<Explorer />}></Route>
              <Route path="/explorer/:id" element={<Explorer />}></Route>

              <Route path="/client" element={<UserPanel role={1} />}></Route>
              <Route path="/client/:id" element={<Client />}></Route>

              <Route path="/referent" element={<UserPanel role={2} />}></Route>
              <Route path="/referent/:id" element={<Referent />}></Route>
            </>}

            <Route path="*" element={<Navigate replace to="/" />}></Route>
          </Routes>
      </BrowserRouter>
  </div>
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
  </React.StrictMode>
);